import { Box, Text } from "@chakra-ui/react";

export function Infos({ label, bg, color, width, border = false }) {
  return (
    <>
      <Box
        textTransform={"uppercase"}
        width={width ? width : "10rem"}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        paddingLeft="1rem"
        paddingBlock={2}
        position="relative"
        bg={bg}
        border={border ? "1px solid #ebebeb" : "none"}
      >
        <Text
          as="span"
          fontWeight={"normal"}
          fontSize={"13px"}
          textTransform={"uppercase"}
          color={color ? color : "#fff"}
        >
          {label}
        </Text>
      </Box>
    </>
  );
}
